module.exports = __webpack_public_path__ + "img/logo-2.083316c5.webp";